import Colors from "../../core/Colors";
import { ALIGN_TYPE, TextType } from "../../ui/type/TextType";
import { ComponentF, createElement } from "../../ui/ui";
import { getLast, isLogStale } from "./logger";

export const LogList: ComponentF<any> = (C) => {
  if (!isLogStale()) {
    return [
      createElement(
        TextType,
        { x: 0, y: 0, w: C.bounds.w, h: 0 },
        { color: Colors.RED, title: getLast(), align: ALIGN_TYPE.center }
      ),
    ];
  }
};
